export default __webpack_public_path__ + "static/media/eduImgBlack.3bf48c9a.svg";